export const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.44 14.3181C27.44 13.3254 27.3509 12.3708 27.1855 11.4545H14V16.8699H21.5346C21.21 18.6198 20.2236 20.1025 18.7409 21.0953V24.6079H23.2655C25.9127 22.1707 27.44 18.5817 27.44 14.3181Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 27.9998C17.78 27.9998 20.9491 26.7461 23.2654 24.6079L18.7409 21.0952C17.4872 21.9352 15.8836 22.4316 14 22.4316C10.3536 22.4316 7.26725 19.9689 6.16634 16.6598H1.48907V20.2871C3.79271 24.8625 8.52725 27.9998 14 27.9998Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.16639 16.6597C5.88639 15.8197 5.7273 14.9225 5.7273 13.9997C5.7273 13.077 5.88639 12.1798 6.16639 11.3398V7.71252H1.4891C0.540912 9.60251 0 11.7407 0 13.9997C0 16.2588 0.540912 18.397 1.4891 20.2869L6.16639 16.6597Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 5.56807C16.0555 5.56807 17.9009 6.27442 19.3518 7.66167L23.3673 3.64629C20.9428 1.38725 17.7737 0 14 0C8.52727 0 3.79272 3.13721 1.48907 7.71257L6.16636 11.3398C7.26727 8.03075 10.3536 5.56807 14 5.56807Z"
      fill="#EA4335"
    />
  </svg>
)
